import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {SalesByHalfHourReportModel} from "./sales-by-half-hour-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-sales-by-half-hour-report",
    templateUrl: "./sales-by-half-hour-report.component.html",
    providers: [provideReportModel(SalesByHalfHourReportModel)]
})
export class SalesByHalfHourReportComponent extends AbstractReportPage {
    constructor(public model: SalesByHalfHourReportModel) {
        super();
    }
}
